module.exports = __webpack_public_path__ + "img/banner3.a6768c56.jpg";